import styled from "styled-components";
import { Select } from "antd";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContainer = styled.div`
  background: white;
  border-radius: 12px;
  width: 450px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  position: relative;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
`;

export const ModalTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  font-family: "Manrope", sans-serif;
  color: #1B2028;
`;

export const CloseIcon = styled.span`
  font-size: 20px;
  cursor: pointer;
  color: #888;
`;

export const ModalContent = styled.div`
  padding: 20px;
  border-bottom: 1px solid #eee;
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StyledSelectField = styled(Select)`
  width: 100%;
  font-family: "Manrope", sans-serif;
  height: auto;
  .ant-select-selector {
    border-radius: 8px !important;
    border: 1px solid #d1d5db !important;
    height: 40px !important;
    padding: 4px 11px !important;
    font-family: "Manrope", sans-serif;
    font-size: 14px;
    background-color: #ffffff !important;
    &:hover {
      border-color: #0C53BB !important;
    }
  }
  
  .ant-select-focused .ant-select-selector {
    border-color: #0C53BB !important;
    box-shadow: 0 0 0 2px rgba(12, 83, 187, 0.1) !important;
  }
  
  .ant-select-selection-placeholder {
    color: #9ca3af !important;
    font-family: "Manrope", sans-serif;
    font-size: 14px;
  }
  
  .ant-select-selection-item {
    font-family: "Manrope", sans-serif;
    font-size: 14px;
    color: #1B2028;
    font-weight: 400 !important;
  }
  
  /* Dropdown menu styling */
  .ant-select-dropdown {
    font-family: "Manrope", sans-serif;
    
    .ant-select-item {
      font-family: "Manrope", sans-serif;
      font-size: 14px;
      font-weight: 400;
      color: #1B2028;
      
      /* Ensure flex layout works for default label alignment */
      .ant-select-item-option-content {
        display: flex;
        justify-content: space-between;
        width: 100%;
      }
      
      &:hover {
        background-color: #f9fafb;
      }
    }
    
    .ant-select-item-option-selected {
      background-color: #F1F6FE !important;
      font-weight: 400 !important;
      color: #1B2028 !important;
      
      &:not(.ant-select-item-option-disabled) {
        background-color: #F1F6FE !important;
      }
    }
    
    .ant-select-item-option-active {
      background-color: #f9fafb !important;
    }
  }
`;

export const PreviewButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const PreviewButton = styled.button`
  display: flex;
  align-items: center;
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  border-radius: 8px;
  height: 40px;
  background-color: transparent;
  color: ${(props) => (props.disabled ? "#AEB8C4" : "#0C53BB")};
  border: none;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  &:hover:not(:disabled) {
    opacity: 0.8;
  }
  &:disabled {
    opacity: 0.6;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px 24px;
  gap: 12px;
`;

export const CancelButton = styled.button`
  font-family: 'Manrope', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  height: 40px;
  border-radius: 8px;
  padding: 10px 20px;
  min-width: 100px;
  border: none;
  background: #F3F4F7;
  color: #1B2028;
  cursor: pointer;
  &:hover {
    background: #f9fafb;
  }
`;

export const ConfirmButton = styled.button`
  font-family: 'Manrope', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  height: 40px;
  border-radius: 8px;
  padding: 10px 20px;
  min-width: 100px;
  border: none;
  background: #0C53BB;
  color: #FFFFFF;
  cursor: pointer;
  &:hover:not(:disabled) {
    background: #0a4299;
  }
  &:disabled {
    background: #d1d5db;
    color: #9ca3af;
    cursor: not-allowed;
    opacity: 0.6;
  }
`; 

export const CancelBtngrp = styled.div`
display : flex;
gap:10px;
`